<p class="ds-w-72">{{ translation.newVersionAvailableMessage(newVersion) }}</p>
